import type React from "react"
import { Outlet } from "react-router-dom"
import { Box } from "@mui/material"
import Header from "../common/Header/Header"


const PrivateLayout: React.FC = () => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
            <Header />
            <Box component="main" sx={{ flexGrow: 1, bgcolor: "#f4f5f5" }}>
                <Outlet />
            </Box>
        </Box>
    )
}

export default PrivateLayout

